module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAqAQMAAADhxGurAAAAAXNSR0IArs4c6QAAAAZQTFRFAAAA/wAAG/+NIgAAAAF0Uk5TAEDm2GYAAAAdSURBVAjXY/gPBB8YMMkPDAwMxJMMg5oE+QgLCQBxVEoR55mfqgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/tab/box_path.png
// module id = ERgo
// module chunks = 70